import React, { useState } from 'react';
import Sidebar from "../components/common/menu/Sidebar";
import Menu from "../components/common/menu/Menu";
import OrdersWorkspace from "../components/orders/OrdersWorkspace";

function OrdersPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = (isOpen) => {
        setSidebarOpen(isOpen);
    };

    return (
        <div className="overflow-hidden dark:bg-dark-950">
            <div className="block md:hidden">
                <Menu sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
            </div>

            <div className="hidden md:block">
                <Sidebar />
            </div>

            <div className="md:ml-[15rem] h-screen overflow-hidden bg-light-blue-50 relative dark:bg-dark-950">
                <div className="absolute inset-0 opacity-[0.04] dark:opacity-0" style={{
                    backgroundImage: 'url(https://i.ibb.co/9kYFDXtW/background-manga.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}></div>

                <div className="relative h-full overflow-hidden">
                    <div className="flex h-full justify-center overflow-hidden">
                        <div className="w-full h-full pt-8 pb-4 lg:pt-20" style={{ maxWidth: '1600px' }}>
                            <div className="mx-2 h-full lg:mx-10">
                                <OrdersWorkspace />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrdersPage;
